export const dietList = [
  {Id: '1', Name: 'Vegetarian'},
  {Id: '2', Name: 'Jain'},
  {Id: '3', Name: 'Non-Vegetarian'},
  {Id: '4', Name: 'Vegan'},
  {Id: '5', Name: 'Eggetarian'},
];
